export default "/_next/static/assets/images/zattoo_brand.2cc3e1cb7f516b10c3d588783761a8b1.png";